export default __webpack_public_path__ + "static/tagline-LGP-logo-2560x1280-93d8f3d3f95f01c3630041b7a7a50043.jpg";